module.exports = __webpack_public_path__ + "img/success.f8fa3ff0.svg";